(function(algolia) {
  'use strict';

  const getAlgoliaResults = algolia.externals.getAlgoliaResults;
  const { config, translations, headerTemplate, productTemplate, footerTemplate } = algolia;

  // Filters for stock policy
  let filters = ''
  let stockPolicyFilter = '';
  // console.log("algolia autocomplete product pluging", algolia)

  if (algolia.config.stock_policy === 'deny') {
    // For 'deny' we will filter out all items based on inventory quantity
    stockPolicyFilter = '';
  } else if (algolia.config.stock_policy === 'continue') {
    /**
     * For 'continue' we will filter on `inventory_available` attribute whose
     * value is dependent on:
     * `inventory_quantity > 0 OR inventory_policy == 'continue'`
     */
    stockPolicyFilter = 'inventory_available:true';
  }
  filters = !stockPolicyFilter ? 'NOT tags:algolia30days' : stockPolicyFilter + ' AND NOT tags:algolia30days'
  algolia.productsPlugin = {
    getSources({ query, setContext }) {
     
      return [
        {
          sourceId: 'products',
          getItems() {
            //console.log("filters", filters)
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + 'products',
                  query,
                  params: {
                    hitsPerPage: config.products_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled,
                    filters: filters,
                    distinct: true,
                    hitsPerPage: 4,
                    ruleContexts: ['enable-redirect-url'],
                  },
                },
              ],
              transformResponse({ results, hits }) {
                
                setContext({
                  nbProducts: results[0].nbHits,
                });
                return hits;
              },
            });
          },
          templates: {
            header({ html, state }) {
              const resource = translations.products;
              return headerTemplate({ html, state }, resource);
            },
            item({ item, html, components }) {
              //console.log("item 1:", item)
              const distinct = config.show_products;
              const variantInfo = !distinct && item.objectID !== item.id ? `?variant= ${item.objectID}` : '';
              const itemLink = `/products/${item.handle}/${variantInfo}`;

              //console.log("item 1:", productTemplate)
              return productTemplate({ item, html, components }, distinct, itemLink);
            },
            noResults() {
              return 'No products found.'
            }
          },
        }
      ];
    },
  }
})(window.algoliaShopify);
